import React from 'react';
import { Empty, Scrollbar, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import _AreaChart from 'codeArt/components/chart/AreaChart';
import { DashedPanel } from 'codeArt/components/accessory';
import _DonutChart from 'codeArt/components/chart/DonutChart';
import _BarChart from 'codeArt/components/chart/BarChart';
import { Util } from 'codeArt/common';
import ModuleSide from 'codeArt/components/ModuleSide';
import { Shifts, Teams, Devices as _Devices } from 'app/constant';
import PeopleAltIcon from '@material-ui/icons/PeopleAlt';
import GroupAddIcon from '@material-ui/icons/GroupAdd';
import AirplayIcon from '@material-ui/icons/Airplay';
import { connect } from 'react-redux';
import { onDeviceStatisticsChange } from 'actions/DeviceStatistics';
import Modal from 'codeArt/components/Modal';
import IconButton from '@material-ui/core/IconButton';
import { DateTime } from 'codeArt/components/DateTime';
import Select from 'codeArt/components/Select';
import { ModalButton } from 'codeArt/components/Button';

class _StatisticsBar extends React.Component {

  constructor() {
    super();
    this.state = {
      opened: false
    }
    this.cache = null;//通过数据缓存，保留更改的临时变量，在提交的时候，再写入到store里
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    let { value, onChange } = this.props;
    if (!Util.equals(prevProps.value, value)) {
      if (onChange)
        onChange(value);
    }
  }

  componentDidMount() {
    let { value } = this.props;
    this.cache = { ...value };
  }

  handleChange(field, v) {
    let { value } = this.props;
    value = { ...value, ...this.cache };
    value[field] = v;
    this.cache = value;
    // let { onDeviceStatisticsChange,value } = this.props;
    // value = {...value};
    // value[field] = v;
    // onDeviceStatisticsChange(value);
  }

  open() {
    this.modal.open();
    this.setState({ opened: true });
  }

  close = () => {
    this.modal.close();
  };

  onClose() {
    this.setState({ opened: false });
  }

  renderTime(value) {
    return <Time value={value} handleChange={this.handleChange} />;
  }

  getSides() {
    let { sides } = this.props;
    sides = sides || [];

    let data = [
      { type: "time", component: Time },
      { type: "team", component: Team },
      { type: "shift", component: Shift },
    ];

    return data.filter((d) => { return sides.find((t) => t == d.type) })
  }

  renderSide() {
    let { value, filter } = this.props;
    let sides = this.getSides();

    return (
      <div className="row py-4">
        {
          sides.map((t, i) => {
            let Component = t.component;
            return <Component key={`${i}`} value={value} handleChange={this.handleChange} />
          })
        }

        {/*<Time value={value} handleChange={this.handleChange} />
        <Team value={value} handleChange={this.handleChange} />
        <Shift value={value} handleChange={this.handleChange} /> */}
        {filter ? filter({ value, handleChange: this.handleChange }) : null}
      </div>
    );
  }

  submit() {
    let { onDeviceStatisticsChange } = this.props;
    onDeviceStatisticsChange(this.cache);
    this.close();
  }

  tools() {
    return [
      <ModalButton key={"params"} color="primary" onClick={() => { this.submit(); }}>确定</ModalButton>,
      <ModalButton key={"close"} color="grey" onClick={() => { this.close(); }}>关闭</ModalButton>
    ];
  }

  render() {
    let { opened } = this.state;
    return (
      <div className="theme-option">
        {opened ? null : <IconButton onClick={this.open.bind(this)}>
          <i className="zmdi zmdi-search text-white" />
        </IconButton>}
        <Modal title={"设置过滤条件"}
          ref={(r) => { this.modal = r; }}
          size="sm"
          onExit={() => { this.onClose(); }}
          tools={this.tools()}>
          {this.renderSide()}
        </Modal>
      </div>
    );
  }

}

_StatisticsBar.defaultProps = {
  sides: ["time", "team", "shift"],
};


const mapStateToProps = ({ DeviceStatistics }) => {
  const { value } = DeviceStatistics;
  return { value };
};

export const StatisticsBar = connect(mapStateToProps, { onDeviceStatisticsChange })(_StatisticsBar);

const Time = ({ value, handleChange }) => {
  return (
    [<div key="startTime" className="col-sm-12 col-lg-6">
      <DateTime mode="dateTime" label="开始时间" field="startTime" depend={{ value: value["startTime"] }} onChange={(v) => { handleChange("startTime", v); }} />
    </div>,
    <div key="endTime" className="col-sm-12 col-lg-6">
      <DateTime mode="dateTime" label="结束时间" field="endTime" depend={{ value: value["endTime"] }} onChange={(v) => { handleChange("endTime", v); }} />
    </div>]
  );
}


const Team = ({ value, handleChange }) => {
  return (
    <div className="col-sm-12 col-lg-6">
      <Select label="工作组" depend={{ value: value["team"] }}
        field="team"
        onChange={(v) => { handleChange("team", v) }}
        options={Teams.map((s) => { return { label: s.Name, value: s.Id } })}
      />
    </div>
  );
}


const Shift = ({ value, handleChange }) => {
  return (
    <div className="col-sm-12 col-lg-6">
      <Select label="班次" depend={{ value: value["shift"] }}
        field="shift"
        onChange={(v) => { handleChange("shift", v) }}
        options={Shifts.map((s) => { return { label: s.Name, value: s.Id } })}
      />
    </div>
  );
}
